import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Modal from '../Modal/Modal';
import OnboardingBackToApp from '../../../pages/Onboarding/OnboardingBackToApp';
import OnboardingUserMenu from '../../../pages/Onboarding/OnboardingUserMenu';
import './ModalDiagramNotFound.scss';

// Shown when a diagram URL can't be opened (not found / no access / wrong URL).
// Not a toggle modal: there's nothing behind it to return to, so it has no close
// affordance (no onCancel — overlay click and Esc do nothing). The only way out
// is back to the diagrams list. Rendered by the Diagram page when the canvas
// fetch flags `isDiagramCanvasNotFound`.
//
// The corner menus mirror the invitation page: "Back to app" (top-left) and the
// "Logged in as…" menu (top-right). They self-guard on currentUser. The wrapper
// scopes a z-index bump so they sit above the modal's dimming overlay.
export const ModalDiagramNotFound = () => {
    const { t, i18n } = useTranslation();
    const history = useHistory();

    useEffect(() => {
        document.title = t('m_diagram_not_found.header');
    }, [t, i18n.language]);

    return (
        <>
            <div className="diagram-not-found-menus">
                <OnboardingBackToApp />
                {/* <OnboardingUserMenu /> */}
            </div>

            <Modal isOpen={true} isModalSmall isModalQuick modalClass="modal-diagram-not-found">
                <div className="modal-content-header">{t('m_diagram_not_found.header')}</div>
                <div className="modal-content-body">
                    <div className="description-text">
                        {t('m_diagram_not_found.desc')}
                    </div>
                    <div className="buttons-wrap">
                        <button onClick={() => history.push('/diagrams/')}>{t('m_diagram_not_found.back_to_app')}</button>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default ModalDiagramNotFound;
